import { render, staticRenderFns } from "./FooterMar.vue?vue&type=template&id=2bf88da6&"
import script from "./FooterMar.vue?vue&type=script&lang=js&"
export * from "./FooterMar.vue?vue&type=script&lang=js&"
import style0 from "./FooterMar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports